var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFiRrUserAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fi-rr-user-add",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.545,
    height: 19.545,
    viewBox: "0 0 19.545 19.545",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6323",
    "data-name": "Path 6323",
    d: "M21.7,10.443H20.072V8.814a.814.814,0,1,0-1.629,0v1.629H16.814a.814.814,0,1,0,0,1.629h1.629V13.7a.814.814,0,1,0,1.629,0V12.072H21.7a.814.814,0,0,0,0-1.629Z",
    transform: "translate(-2.97 -1.485)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6324",
    "data-name": "Path 6324",
    d: "M7.886,9.772A4.886,4.886,0,1,0,3,4.886,4.886,4.886,0,0,0,7.886,9.772Zm0-8.144A3.257,3.257,0,1,1,4.629,4.886,3.257,3.257,0,0,1,7.886,1.629Z",
    transform: "translate(-0.557)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6325",
    "data-name": "Path 6325",
    d: "M7.329,14A7.337,7.337,0,0,0,0,21.329a.814.814,0,1,0,1.629,0,5.7,5.7,0,0,1,11.4,0,.814.814,0,0,0,1.629,0A7.337,7.337,0,0,0,7.329,14Z",
    transform: "translate(0 -2.599)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrUserAdd);
export default __webpack_public_path__ + "static/media/fi-rr-user-add.fa5acf7a.svg";
export { ForwardRef as ReactComponent };